export const ActionsDefaultState = {
  send: 'Отправить заявку',
  revoke: 'Отозвать заявку',
  comment: 'Комментарий',
  lastComment: 'Последний комментарий',
  visible: [
    'send', 'revoke'
  ]
};


/*
 Status:
 0 - Черновик
 14 - На проверке
 18 - На согласовании
 7 - Отправлено
 */

// TODO: Use it if need it
export const ActionsRules = {
  user: {
    0: {
      send: 'На проверку',
      visible: ['send', 'personal/send'],
      comment: 'Согласие на обработку персональных данных',
      lastComment: null,
    },
    // 14: {
    //   ...ActionsDefaultState,
    //   visible: []
    // },
    // 18: {
    //   send: 'Согласовать',
    //   revoke: 'Отказаться',
    //   comment: {
    //     revoke: 'Причина отказа',
    //     send: 'Данные согласующего'
    //   },
    //   commentTitle: 'Пожалуйста, поясните причину отказа',
    //   lastComment: 'Что изменилось в анкете?',
    //   lastCommentColor: '#ff5050',
    //   visible: [...ActionsDefaultState.visible, 'personal/revoke', 'personal/send', 'comment/revoke'],
    //   showOnLoad: true,
    //   mainPageAlert: `Уважаемый участник<br /><br />
    //     В анкету были внесены изменения с целью приведения данных по компаниям-участникам Фонда “Сколково” к единообразию.<br /><br />
    //     Просим ознакомиться и согласовать изменения.`
    // },
    // 7: {
    //   visible: []
    // }
  },
  // verificator: {
  //   0: {
  //     ...ActionsDefaultState,
  //     visible: []
  //   },
  //   14: {
  //     send: 'Опубликовать',
  //     revoke: 'Вернуть на согласование',
  //     comment: 'Что изменилось в анкете?',
  //     lastComment: 'Комментарий компании участника',
  //     lastCommentColor: '#50abff',
  //     revokeColor: '#ff5050',
  //     visible: [...ActionsDefaultState.visible, 'comment/revoke']
  //   },
  //   18: {
  //     ...ActionsDefaultState,
  //     visible: []
  //   },
  //   7: {
  //     ...ActionsDefaultState,
  //     visible: []
  //   }
  // }
};
